import React, { useEffect, useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { Image } from 'primereact/image';
import { Tooltip } from 'primereact/tooltip';
import '../CatalogoClientes.scss';
import { addContact, deleteContact, getClientData, getOptions, updateClient } from "../Integracion";
import { useParams } from "react-router-dom";
import { parseDate } from "../../../../utilidades/formateos";
import Swal from "sweetalert2";
import { ContactDialog } from "./Contactdialog";

const ClientesForm = () => {
    const { id } = useParams();
    const logoUploadRef = useRef(null);

    const [formData, setFormData] = useState(null);
    const [colaboradores, setColaboradores] = useState([]);
    const [classification, setClassification] = useState([]);
    const [zonas, setZonas] = useState([]);
    const [imagePreview, setImagePreview] = useState(null);
    const [imageExists, setImageExists] = useState(false);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [contactos, setContactos] = useState([]);
    const [rutas, setRutas] = useState([]);

    useEffect(() => {
        if (id) {
            getClientData(id).then((data) => {
                setFormData(data);
                setRutas(data.rutas);
                setContactos(data.contact);
            })
        } else {
            setFormData({
                empresa: '',
                razonSocial: '',
                direccion: '',
                colonia: '',
                telefono1: '',
                telefono2: '',
                email: '',
                inicioServicio: new Date(),
                inicioContrato: new Date(),
                vContrato: new Date(),
                municipio: '',
                codigo: '',
                fax: '',
                rfc: '',
                nota: '',
                categoria: '',
                clienteODOO: '',
                link: '',
                latitud: '',
                longitud: '',
                imagen: '',
                iniciales: '',
                nip: '',
                logo: '',
                logoFile: null,
                politicaTaxi: '',
                politicaServicio: '',
            })
        }
        getOptions().then((data) => {
            setRutas(data);
            setColaboradores(data.collaborator);
            setClassification(data.classification);
            setZonas(data.zona);
        })
    }, [id]);

    useEffect(() => {
        return () => {
            if (imagePreview) {
                URL.revokeObjectURL(imagePreview);
            }
        };
    }, [imagePreview]);

    useEffect(() => {
        if (formData?.logo && !imagePreview) {
            const img = new window.Image();
            img.onload = () => setImageExists(true);
            img.onerror = () => setImageExists(false);
            img.src = `https://repo.sumaenlinea.mx/img/logo-cliente/${formData.logo}`;
        } else {
            setImageExists(false);
        }
    }, [formData?.logo, imagePreview]);

    const onLogoSelect = (e) => {
        const file = e.files[0];
        if (file) {
            const previewUrl = URL.createObjectURL(file);
            setImagePreview(previewUrl);
            setFormData(prev => ({
                ...prev,
                logoFile: file,
                logo: file.name
            }));
        }
    };

    const onLogoRemove = () => {
        if (imagePreview) {
            URL.revokeObjectURL(imagePreview);
            setImagePreview(null);
        }

        if (logoUploadRef.current) {
            logoUploadRef.current.clear();
            setFormData(prev => ({
                ...prev,
                logoFile: null,
                logo: ''
            }));
        }
    };

    const handleInputChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSaveContact = (colaborador) => {
        const nuevoContacto = {
            id: colaborador.id,
            nombre: colaborador.nombre,
            correo: colaborador.correo,
            tipo: 'INPLANT',
            telefono: colaborador.telefono,
            activo: true
        };

        setContactos([...contactos, nuevoContacto]);
        addContact({ idClient: id, idUser: colaborador.id }).then(() => {
            Swal.fire('Éxito', 'Contacto agregado exitosamente', 'success').then(() => {
                setDialogVisible(false);
            })
        }).catch(error => {
            Swal.fire('Error', 'No se pudo guardar el contacto', 'error').then(() => {
                setDialogVisible(false);
            })
        })
    };

    const handleDeleteContact = (colaborador) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: `¿Deseas eliminar al colaborador ${colaborador.nombre}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                deleteContact({ idClient: id, idUser: colaborador.id })
                    .then(() => {
                        setContactos((prev) => prev.filter((c) => c.id !== colaborador.id));
                        Swal.fire('Eliminado', 'El colaborador ha sido eliminado correctamente', 'success');
                    })
                    .catch((error) => {
                        console.error('Error al eliminar contacto:', error);
                        Swal.fire('Error', 'No se pudo eliminar el colaborador', 'error');
                    });
            }
        });
    };

    const handleSave = async () => {
        try {
            const formDataToSend = new FormData();

            Object.keys(formData).forEach(key => {
                if (!key.includes('File') && formData[key] !== null && formData[key] !== undefined) {
                    if (formData[key] instanceof Date) {
                        formDataToSend.append(key, formData[key].toISOString());
                    } else if (typeof formData[key] === 'object' && formData[key].code) {
                        formDataToSend.append(key, formData[key].code);
                    } else {
                        formDataToSend.append(key, formData[key]);
                    }
                }
            });

            if (formData.logoFile) {
                formDataToSend.append('logoFile', formData.logoFile);
            }

            if (id) {
                formDataToSend.append('id', id);
            }

            await updateClient(formDataToSend);
            Swal.fire('Éxito', 'Cliente guardado correctamente', 'success');

        } catch (error) {
            console.error('Error al guardar cliente:', error);
            Swal.fire('Error', 'No se pudo guardar el cliente', 'error');
        }
    };

    const activoTemplate = (rowData) => {
        return rowData.activo || rowData.activa ?
            <i className="pi pi-check-circle text-green-500"></i> :
            <i className="pi pi-times-circle text-red-500"></i>;
    };

    return (
        <div className="service-panel">
            <Tooltip target=".tooltip-wrapper" />

            {/* Header */}
            <div className="service-panel__header shadow-2">
                <div className="flex flex-wrap justify-content-between align-items-center gap-3 md:p-3 mx-auto">
                    <h1 className="text-2xl md:text-3xl font-semibold m-0 flex align-items-center gap-3">
                        <i className="pi pi-users"></i>
                        Catálogo de Clientes
                    </h1>
                    <div className="flex gap-2 flex-wrap">
                        <Button
                            label="Guardar"
                            icon="pi pi-save"
                            severity="success"
                            onClick={handleSave}
                        />
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="md:pt-4 md:pb-4 mx-auto">
                {/* Información General */}
                <Card className="mb-2 shadow-2">
                    <h2 className="text-xl font-semibold mb-4 pb-3 border-bottom-1 surface-border flex align-items-center gap-2">
                        <i className="pi pi-info-circle"></i>
                        Información General
                    </h2>

                    <div className="service-panel__form-grid">
                        {/* Fila 1: Identificación básica - 5 campos */}
                        <div className="service-panel__form-group">
                            <label>ID</label>
                            <InputText value={id ? formData?.id : 'Nuevo'} disabled />
                        </div>

                        <div className="service-panel__form-group">
                            <label>Iniciales</label>
                            <InputText
                                value={formData?.iniciales}
                                onChange={(e) => handleInputChange('iniciales', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group">
                            <label>NIP</label>
                            <InputText
                                value={formData?.nip}
                                onChange={(e) => handleInputChange('nip', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group">
                            <label>Categoría</label>
                            <Dropdown
                                value={classification.find(clas => clas.code === (formData?.categoriaId?.code ?? formData?.categoriaId))}
                                options={classification}
                                optionLabel="name"
                                onChange={(e) => handleInputChange('categoriaId', e.value)}
                                placeholder="Seleccionar"
                                filter
                            />
                        </div>

                        <div className="service-panel__form-group">
                            <label>Cliente ODOO</label>
                            <InputText
                                value={formData?.clienteODOO}
                                onChange={(e) => handleInputChange('clienteODOO', e.target.value)}
                            />
                        </div>

                        {/* Fila 2: LINK y Empresa */}
                        <div className="service-panel__form-group">
                            <label>LINK</label>
                            <InputText
                                value={formData?.link}
                                onChange={(e) => handleInputChange('link', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group service-panel__form-group--span-2">
                            <label>Empresa</label>
                            <InputText
                                value={formData?.empresa}
                                onChange={(e) => handleInputChange('empresa', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group service-panel__form-group--span-2">
                            <label>Razón Social</label>
                            <InputText
                                value={formData?.razonSocial}
                                onChange={(e) => handleInputChange('razonSocial', e.target.value)}
                            />
                        </div>

                        {/* Fila 3: Dirección */}
                        <div className="service-panel__form-group service-panel__form-group--span-3">
                            <label>Dirección</label>
                            <InputText
                                value={formData?.direccion}
                                onChange={(e) => handleInputChange('direccion', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group">
                            <label>Colonia</label>
                            <InputText
                                value={formData?.colonia}
                                onChange={(e) => handleInputChange('colonia', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group">
                            <label>Municipio</label>
                            <InputText
                                value={formData?.municipio}
                                onChange={(e) => handleInputChange('municipio', e.target.value)}
                            />
                        </div>

                        {/* Fila 4: Teléfonos y Email */}
                        <div className="service-panel__form-group">
                            <label>Teléfono 1</label>
                            <InputText
                                value={formData?.telefono1}
                                onChange={(e) => handleInputChange('telefono1', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group">
                            <label>Teléfono 2</label>
                            <InputText
                                value={formData?.telefono2}
                                onChange={(e) => handleInputChange('telefono2', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group">
                            <label>Fax</label>
                            <InputText
                                value={formData?.fax}
                                onChange={(e) => handleInputChange('fax', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group service-panel__form-group--span-2">
                            <label>Email</label>
                            <InputText
                                type="email"
                                value={formData?.email}
                                onChange={(e) => handleInputChange('email', e.target.value)}
                            />
                        </div>

                        {/* Fila 5: RFC y Código */}
                        <div className="service-panel__form-group">
                            <label>RFC</label>
                            <InputText
                                value={formData?.rfc}
                                onChange={(e) => handleInputChange('rfc', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group">
                            <label>Código</label>
                            <InputText
                                value={formData?.codigo}
                                onChange={(e) => handleInputChange('codigo', e.target.value)}
                            />
                        </div>

                        {/* Fila 6: Fechas */}
                        <div className="service-panel__form-group">
                            <label>Inicio Servicio</label>
                            <Calendar
                                value={parseDate(formData?.inicioServicio)}
                                onChange={(e) => handleInputChange('inicioServicio', e.value)}
                                dateFormat="dd/mm/yy"
                                showIcon
                            />
                        </div>

                        <div className="service-panel__form-group">
                            <label>Inicio Contrato</label>
                            <Calendar
                                value={parseDate(formData?.inicioContrato)}
                                onChange={(e) => handleInputChange('inicioContrato', e.value)}
                                dateFormat="dd/mm/yy"
                                showIcon
                            />
                        </div>

                        <div className="service-panel__form-group">
                            <label>Vencimiento Contrato</label>
                            <Calendar
                                value={parseDate(formData?.vContrato)}
                                onChange={(e) => handleInputChange('vContrato', e.value)}
                                dateFormat="dd/mm/yy"
                                showIcon
                            />
                        </div>

                        {/* Separador para sección de archivos */}
                        <div className="service-panel__form-group service-panel__form-group--full mt-3 pt-3 border-top-1 surface-border">
                            <h3 className="text-lg font-semibold m-0 flex align-items-center gap-2">
                                <i className="pi pi-cloud-upload"></i>
                                Documentos y Archivos
                            </h3>
                        </div>

                        {/* Fila 7: Archivos */}
                        <div className="service-panel__form-group">
                            <label>Logo (Imagen)</label>

                            <span
                                data-pr-tooltip={!id ? "Debes guardar el cliente primero para subir un logo" : ""}
                                data-pr-position="top"
                                className="tooltip-wrapper"
                            >
                                <FileUpload
                                    ref={logoUploadRef}
                                    mode="basic"
                                    name="logo"
                                    accept="image/*"
                                    maxFileSize={5000000}
                                    onSelect={onLogoSelect}
                                    auto
                                    chooseLabel={formData?.logo ? 'Cambiar Logo' : 'Seleccionar Logo'}
                                    className="service-panel__file-upload"
                                    disabled={!id}
                                />
                            </span>

                            {(formData?.logo || imagePreview) && (
                                <div className="service-panel__file-preview mt-3 p-3 surface-100 border-round border-1 surface-border">
                                    {imagePreview ? (
                                        <Image
                                            src={imagePreview}
                                            alt="Preview del logo"
                                            width="200"
                                            preview
                                            className="border-round"
                                        />
                                    ) : imageExists ? (
                                        <Image
                                            src={`https://repo.sumaenlinea.mx/img/logo-cliente/${formData.logo}`}
                                            alt="Logo del cliente"
                                            width="200"
                                            preview
                                            className="border-round"
                                        />
                                    ) : (
                                        <div className="image-placeholder">
                                            <i className="pi pi-image"></i>
                                            <span>{formData.logo}</span>
                                        </div>
                                    )}

                                    <Button
                                        icon="pi pi-times"
                                        rounded
                                        severity="danger"
                                        onClick={onLogoRemove}
                                        tooltip="Eliminar logo"
                                    />
                                </div>
                            )}
                        </div>

                        <div className="service-panel__form-group service-panel__form-group--span-2">
                            <label>Política Taxis</label>
                            <InputText
                                value={formData?.politicaTaxi}
                                onChange={(e) => handleInputChange('politicaTaxi', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group service-panel__form-group--span-2">
                            <label>Política Servicio</label>
                            <InputText
                                value={formData?.politicaServicio}
                                onChange={(e) => handleInputChange('politicaServicio', e.target.value)}
                            />
                        </div>

                        {/* Ubicación */}
                        <div className="service-panel__form-group">
                            <label>Latitud</label>
                            <InputText
                                value={formData?.latitud}
                                onChange={(e) => handleInputChange('latitud', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group">
                            <label>Longitud</label>
                            <InputText
                                value={formData?.longitud}
                                onChange={(e) => handleInputChange('longitud', e.target.value)}
                            />
                        </div>

                        <div className="service-panel__form-group">
                            <label>Zona</label>
                            <Dropdown
                                value={zonas.find(zona => zona.code === (formData?.zona?.code ?? formData?.zona))}
                                options={zonas}
                                optionLabel="name"
                                onChange={(e) => handleInputChange('zona', e.value)}
                                placeholder="Seleccionar"
                                filter
                            />
                        </div>

                        {/* Nota */}
                        <div className="service-panel__form-group service-panel__form-group--full">
                            <label>Nota</label>
                            <InputTextarea
                                value={formData?.nota}
                                onChange={(e) => handleInputChange('nota', e.target.value)}
                                rows={3}
                            />
                        </div>
                    </div>
                </Card>

                {/* Tabs */}
                <Card className="shadow-2">
                    <TabView>
                        <TabPanel header="Mapa" leftIcon="pi pi-map-marker">
                            <div className="service-panel__map-container border-round overflow-hidden shadow-2">
                                <iframe
                                    src={`https://maps.google.com/maps?q=${formData?.latitud},${formData?.longitud}&z=15&output=embed`}
                                    style={{ border: 0, width: '100%', height: '400px' }}
                                    allowFullScreen
                                    loading="lazy"
                                ></iframe>
                            </div>
                        </TabPanel>

                        <TabPanel header="Contactos" leftIcon="pi pi-users">
                            <div className="flex justify-content-end mb-3">
                                <Button
                                    label="Agregar"
                                    icon="pi pi-plus"
                                    severity="success"
                                    onClick={() => setDialogVisible(true)}
                                />
                            </div>

                            <DataTable value={contactos}>
                                <Column
                                    header="Acciones"
                                    body={(rowData) => (
                                        <div className="service-panel__row-actions">
                                            <Button
                                                icon="pi pi-trash"
                                                onClick={() => handleDeleteContact(rowData)}
                                                rounded
                                                severity="danger"
                                                // El tipo puede venir como 'INPLANT' o 'in-plant'
                                                disabled={String(rowData.tipo ?? '').replace(/[^a-z]/gi, '').toUpperCase() !== 'INPLANT'}
                                            />
                                        </div>
                                    )}
                                    style={{ width: '120px' }}
                                />
                                <Column field="nombre" header="Nombre" />
                                <Column field="correo" header="Email" />
                                <Column field="tipo" header="Tipo" />
                                <Column field="telefono" header="Teléfono" />
                                <Column
                                    field="activo"
                                    header="Activo"
                                    body={activoTemplate}
                                    style={{ width: '100px' }}
                                />
                            </DataTable>

                            <ContactDialog
                                visible={dialogVisible}
                                onHide={() => setDialogVisible(false)}
                                colaboradores={colaboradores}
                                onSave={handleSaveContact}
                            />
                        </TabPanel>

                        {rutas.length > 0 && (
                            <TabPanel header="Rutas" leftIcon="pi pi-directions">
                                <DataTable value={rutas}>
                                    <Column field="id" header="ID" style={{ width: '100px' }} />
                                    <Column field="nombre" header="Nombre" />
                                    <Column
                                        field="activa"
                                        header="Activa"
                                        body={activoTemplate}
                                        style={{ width: '100px' }}
                                    />
                                </DataTable>
                            </TabPanel>
                        )}
                    </TabView>
                </Card>
            </div>
        </div>
    );
};

export default ClientesForm;